export default "__VITE_ASSET__7114c848__"